import { quizAnswersSchema } from '@quiz-marketing/contracts';

const key = 'pae-quiz-draft-v3';
const maxAge = 7 * 24 * 60 * 60 * 1000;

// ponytail: solo respuestas, sin datos de contacto; recuperación en este navegador durante 7 días.
export function readQuizDraft(storage, now = Date.now()) {
  try {
    const draft = JSON.parse(storage.getItem(key));
    const parsed = quizAnswersSchema.partial().safeParse(draft?.answers);
    if (!parsed.success || !Number.isFinite(draft.updatedAt) || now - draft.updatedAt > maxAge || draft.updatedAt > now) return null;
    const answers = parsed.data;
    const keys = Object.keys(quizAnswersSchema.shape);
    const missing = keys.findIndex(k => !answers[k]);
    const furthest = missing < 0 ? keys.length : missing;
    return { answers, step: Number.isInteger(draft.step) ? Math.max(0, Math.min(draft.step, furthest)) : furthest };
  } catch { return null; }
}

export function saveQuizDraft(storage, answers, step) {
  try { storage.setItem(key, JSON.stringify({ answers, step, updatedAt: Date.now() })); } catch { /* El quiz funciona también sin almacenamiento disponible. */ }
}

export function clearQuizDraft(storage) {
  try { storage.removeItem(key); } catch { /* Almacenamiento bloqueado por el navegador. */ }
}
